import React from 'react';
import classnames from 'classnames';
import { PapiDeviation } from '@wix/da-papi-types';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';
import { scaleToSize } from '../_helpers';
import MediaService from '../../utils/DeviationMediaService';
import BlurredBackground from '../Full/_partials/BlurredBackground';

import hiddenStyles from './Hidden.scss';

export interface Props {
  deviation: PapiDeviation;
  icon: React.ReactNode;
  compact?: boolean;
  showBackground?: boolean;
  strict?: boolean;
  title?: string;
  className?: string;
  text?: React.ReactNode;
  width?: number;
  height?: number;
  button?: React.ReactNode;
  secondaryButton?: React.ReactNode;
}

const HiddenLayout: React.FC<Props> = ({
  icon,
  compact,
  showBackground = true,
  strict,
  title,
  text,
  className,
  button,
  secondaryButton,
  deviation,
  width,
  height,
}) => {
  const background = MediaService.getSmallestThumb(deviation);
  const fullImage = MediaService.getFullviewForSize(deviation, width, height);
  const childBoxSize = fullImage ? scaleToSize(fullImage, { width, height }) : { width, height };

  const consistent_devpage_blur = useFlag('consistent_devpage_blur');
  const dontBlockImage = consistent_devpage_blur && !showBackground;
  // todo: does it break where showBackground={false} in existing/non-consistent_devpage_blur code?
  // e.g. TierPromotionCardEditorDumb, TierPromotionCardSemiDumb, TierSidebarCard
  const textClassName = title ? hiddenStyles['blocked-text'] : hiddenStyles['blocked-text-large'];
  const textNodes = (!Array.isArray(text) ? [text] : text).filter(Boolean);
  return (
    <div
      style={{ width, height }}
      className={classnames(
        className,
        hiddenStyles['root'],
        compact && hiddenStyles['compact'],
        strict && hiddenStyles['strict'],
        dontBlockImage && hiddenStyles['consistent_devpage_blur-transparent-bg']
      )}
    >
      <div style={childBoxSize} className={hiddenStyles['blocked-placeholder']}>
        {showBackground && background && (
          <BlurredBackground imageUrl={background.src} clientSideBlur />
        )}
        <div className={hiddenStyles['blocked-wrap']}>
          <div className={hiddenStyles['blocked-icon']}>{icon}</div>
          {title && <div className={hiddenStyles['blocked-title']}>{title}</div>}
          {textNodes.map((node, idx) => (
            <div key={`${idx}`} className={textClassName}>{node}</div>
          ))}
          {button}
          {secondaryButton}
        </div>
      </div>
    </div >
  );
};
HiddenLayout.displayName = 'HiddenLayout';

export default HiddenLayout;
